/**
 * The relay's own refusals of a node shell's open (`node.shell.subscribe`, packages/api/src/relay/shell.ts), AIOE's,
 * before the node hears of it. The `closed` reason starts with one of these, then `: ` and a sentence for the person.
 * The node's own refusals are `NODE_SHELL_ERRORS` (schemas/nodeShell.ts, the workbench's). No DOM or React Native here,
 * so the console, the phone and node:test all use it.
 */
import { NODE_SHELL_ERRORS } from "../schemas/nodeShell.js";
export const SHELL_RELAY_ERRORS = {
    /** The machine is a desktop: a shell is for nodes only. The node's own word for "no shell here". */
    unavailable: NODE_SHELL_ERRORS.unavailable,
    /** The person is neither the node's owner nor an administrator of its organisation. */
    forbidden: "shell_forbidden",
    /** The node was not granted shell:read, or shell:write to type. */
    scope: "shell_scope",
    /** Typing needs a recent sign-in. */
    signInAgain: "sign_in_again",
    /** The organisation has as many shells open as the platform allows. */
    limit: "shell_limit",
    /** Mojo Up AI Cloud: the organisation is not on Teams. */
    teamsRequired: "teams_required",
};
//# sourceMappingURL=shellRelay.js.map